import { IApiResponse } from "../../models";

/* eslint-disable no-unused-vars */
export interface IRequestOtpRequestBody {
  userId: string;
}
export interface IRequestOtpResponse extends IApiResponse {
  data: IRequestOtpResponseBody;
}
export interface IRequestOtpResponseBody {
  responseCode: string;
  responseMessage: string;
}
export interface IValidateOtpRequestBody {
  otp: number;
  type: EOTPType;
  phoneNumber?: string;
  userId?: string;
}
export interface IValidateOtpResponse extends IApiResponse {
  data: IValidateOtpResponseData;
}
export interface IValidateOtpResponseData {
  valid: boolean;
}
export enum EOTPType {
  WAFFY_OTP = "WAFFY_OTP",
  ABSHER_OTP = "ABSHER_OTP",
}
